import { getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';
var hasCommandModifier = KeyBindingUtil.hasCommandModifier;
export var keyBindings = function keyBindings(event) {
  if (event.keyCode === 8 && hasCommandModifier(event)) {
    return 'backspace';
  }
  return getDefaultKeyBinding(event);
};